import { User, Paginator, Option } from '@/types/index'
import { snakeCaseObject } from '@/helper/formatter'
import { requests, responseBody } from '../http/axios'
import { removeNullParams } from '@/helper/formatter'

export type UserFilters = {
  companyId?: string | number
  limit?: number
  page?: number
}
export const UserService = {
  getUserOptions: async (params: { role?: string }): Promise<Option[]> =>
    await requests.get(`user_options?` + removeNullParams(params).toString()),

  getUser: async (id: number | string): Promise<User> =>
    await requests.get(`users/${id}`).then(responseBody),

  getUsers: async (params: UserFilters): Promise<Paginator<User>> =>
    await requests.get(`users?` + removeNullParams(params).toString()),

  updateUser: async (user: User): Promise<User> =>
    await requests
      .put(`users/${user.id}`, snakeCaseObject(user))
      .then(responseBody),

  switchAdminCompany: async (user: User, companyId: number): Promise<void> =>
    await requests.put(`users/${user.id}/switch_company`, { companyId }),

  createUser: async (user: User): Promise<User> =>
    await requests.post(`users`, snakeCaseObject(user)).then(responseBody),

  removeUser: async (id: number): Promise<void> =>
    await requests.delete(`users/${id}`),
}
